
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { Card } from "@/components/ui/card";
import { OrganizationSize, OrganizationType } from '@/types/assessment';

interface BenchmarkComparisonProps {
  dimensionScores: Record<string, number>;
  organizationType?: OrganizationType;
  size: OrganizationSize;
}

export const BenchmarkComparison = ({ 
  dimensionScores,
  organizationType,
  size 
}: BenchmarkComparisonProps) => {
  // Adjust benchmark based on organization type and size
  const getContextualBenchmark = (dimension: string) => {
    const baseBenchmark = 3.5;
    
    // Size-based adjustments with null check
    let sizeAdjustment = 0;
    if (size) {
      sizeAdjustment = size === "1-10 staff" ? -0.2 :
                       size === "11-100 staff" ? -0.1 :
                       size === "More than 100,000 staff" ? 0.3 : 0;
    }

    // Type-based adjustments
    const typeAdjustment = organizationType === "Government" ? -0.1 :
                          organizationType === "Private - For Profit" ? 0.2 :
                          organizationType === "Academic Institution" ? 0.1 : 0;

    return baseBenchmark + sizeAdjustment + typeAdjustment;
  };

  const barData = Object.entries(dimensionScores).map(([dimension, score]) => {
    const contextualBenchmark = getContextualBenchmark(dimension);
    return {
      name: dimension.charAt(0).toUpperCase() + dimension.slice(1),
      score,
      benchmark: contextualBenchmark,
      gap: Math.abs(score - contextualBenchmark)
    };
  });

  return (
    <Card className="p-4">
      <div className="h-[400px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={barData} margin={{ top: 20, right: 30, bottom: 20, left: 30 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis 
              dataKey="name" 
              stroke="#374151"
              tick={{ fill: "#374151", fontSize: 12 }}
            />
            <YAxis 
              stroke="#374151"
              tick={{ fill: "#374151", fontSize: 12 }}
              domain={[0, 5]}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'white',
                border: '1px solid #e5e7eb',
                borderRadius: '6px'
              }}
            />
            <Legend />
            <Bar dataKey="score" fill="#2563eb" name="Your Score" />
            <Bar dataKey="benchmark" fill="#9333ea" name="Industry Average" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};
